/* RESPONSIBLE TEAM: team-proactive-support */
import RulesetLink from '../ruleset-link';
import { objectTypes } from 'embercom/models/data/matching-system/matching-constants';

export default RulesetLink.extend({
  objectType: objectTypes.article,
});
